import { NavLink } from "react-router-dom";
import { cn } from "../../lib/utils";
import {
  Database,
  TrendingUp,
  LineChart,
  Cpu,
  Target,
  MessageCircle,
  Upload,
  ScrollText,
} from "lucide-react";

const navGroups = [
  {
    title: "Données",
    items: [
      { to: "/stock", label: "Stock", icon: Database },
      { to: "/stockprices", label: "Stock Prices", icon: TrendingUp },
      { to: "/yahoo-finance", label: "Yahoo Finance", icon: LineChart },
    ],
  },
  {
    title: "Prédictions",
    items: [
      { to: "/predictor", label: "Predictor", icon: Cpu },
      { to: "/prediction", label: "Prediction", icon: Target },
      { to: "/comment", label: "Comment", icon: MessageCircle },
    ],
  },
  {
    title: "Outils",
    items: [
      { to: "/import-stocktwits", label: "Import Stocktwits", icon: Upload },
      { to: "/import-logs", label: "Import Logs", icon: ScrollText },
    ],
  },
];

export function SidebarContent({ onNavigate }) {
  return (
    <div className="space-y-1 px-3">
      {navGroups.map((group) => (
        <div key={group.title}>
          <div className="text-xs uppercase tracking-wider text-muted-foreground font-semibold mb-2 mt-4 px-2">
            {group.title}
          </div>
          <nav className="space-y-1">
            {group.items.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={onNavigate}
                  className={({ isActive }) =>
                    cn(
                      "flex items-center rounded-md px-3 py-2 text-sm font-medium transition-colors",
                      isActive
                        ? "bg-primary text-primary-foreground"
                        : "text-foreground hover:bg-accent hover:text-accent-foreground"
                    )
                  }
                >
                  {Icon && <Icon className="mr-2 h-4 w-4" />}
                  {item.label}
                </NavLink>
              );
            })}
          </nav>
        </div>
      ))}
    </div>
  );
}

export function Sidebar() {
  return (
    <aside className="hidden lg:flex flex-col w-[260px] h-screen sticky top-0 self-start border-r bg-background overflow-y-auto py-2">
      <SidebarContent />
    </aside>
  );
}
